/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */

// Note: unset .env variables are represented by empty strings

export const UPLOAD_API_BASE_URL =
  import.meta.env.APP_UPLOAD_API_BASE_URL.length > 0
    ? import.meta.env.APP_UPLOAD_API_BASE_URL
    : 'https://webservice-us-east-1-prod.rra.firetv.amazon.dev';
export const STAGE =
  import.meta.env.APP_STAGE.length > 0
    ? import.meta.env.APP_STAGE
    : 'prod';
export const REGION =
  import.meta.env.APP_REGION.length > 0
    ? import.meta.env.APP_REGION
    : 'us-east-1';

/**
 * Check if the current stage is a development stage (alpha or beta)
 */
export const isDevelopmentStage = () => {
  const stage = STAGE.toLowerCase();
  return stage === 'alpha' || stage === 'beta';
};
